export const FirebaseConfig = {
  apiKey: "AIzaSyA79cktvktD-OIC_atyYRJeDVVh2QgBQYU",
  authDomain: "tti-influencer-quick-check.firebaseapp.com",
  databaseURL: "https://tti-influencer-quick-check.firebaseio.com/",
};
